import type { ReactNode } from 'react'

// Loading, error and empty states sit inside role='table', which only accepts rows.
const StateRow = ({ children }: { children: ReactNode }) => (
  <div role='row'>
    <div role='cell'>{children}</div>
  </div>
)

export default StateRow
